/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { VEP_RESULTS_AVAILABILITY_DURATION } from 'src/content/app/tools/vep/services/vepStorageServiceConstants';

import type {
  VepSubmission,
  SubmissionStatus
} from 'src/content/app/tools/vep/types/vepSubmission';

// Results of the submission will no longer be available from the backend;
// but the submission parameters may still be available on the client; so that the submission may be resubmitted
export const areVepSubmissionResultsExpired = (
  submission: Pick<VepSubmission, 'submittedAt'>
) => {
  const { submittedAt } = submission;

  if (submittedAt) {
    return Date.now() - submittedAt > VEP_RESULTS_AVAILABILITY_DURATION;
  }

  return false;
};

const failedVepSubmissionStatuses: SubmissionStatus[] = [
  'FAILED',
  'UNSUCCESSFUL_SUBMISSION'
];

export const isFailedVepSubmission = (
  submission: Pick<VepSubmission, 'status'>
) => failedVepSubmissionStatuses.includes(submission.status);
